import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { CurrentUser, PrivaAuthCurrentUserService } from '@priva/auth/current-user';

import { CurrentUserActions } from '.';

@Injectable({
    providedIn: 'root',
})
export class CurrentUserEffects {
    constructor(
        private actions$: Actions,
        private privaAuthCurrentUserService: PrivaAuthCurrentUserService,
    ) {}

    loadCurrentUser$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CurrentUserActions.loadCurrentUser),
            mergeMap(() =>
                this.privaAuthCurrentUserService.user.pipe(
                    map((currentUser: CurrentUser) =>
                        CurrentUserActions.loadCurrentUserSuccess({ currentUser }),
                    ),
                    catchError((error) => of(CurrentUserActions.loadCurrentUserFailure({ error }))),
                ),
            ),
        );
    });
}
